import { SearchAPI } from "@radarly/api/search";
import { SearchData, SearchParams } from "@radarly/models/search";
import { SearchRepository } from "./SearchRepository";

const searchAPI = new SearchAPI();

export class APISearchRepository implements SearchRepository {
  async searchFragmentData<T extends SearchData>(
    project: number,
    query: SearchParams,
    mutualized?: boolean
  ) {
    return await searchAPI.search<T>(project, query, mutualized);
  }
}
